const SET_CAP_APPLICATIONS = 'SET_CAP_APPLICATIONS';
const SET_CAP_CONTROLLER = 'SET_CAP_CONTROLLER';
const SET_CURRENT_YEAR = 'SET_CURRENT_YEAR';
const SET_OUTBOUND_BUTTON_STATUS = 'SET_OUTBOUND_BUTTON_STATUS';

export const CAP_APPLICATIONS_ACTION_TYPES = {
    SET_CAP_APPLICATIONS,
    SET_CAP_CONTROLLER,
    SET_CURRENT_YEAR,
    SET_OUTBOUND_BUTTON_STATUS,
};
